export default __webpack_public_path__ + "static/media/GoldFrame04.10721e07.png";